import { createTheme } from "@mui/material";
export const myGlobalTheme = createTheme({
  breakpoints: {
    values: {
      mobile: 0,
      smartPhone:350,
      tablet: 765,
      laptop: 1024,
      desktop: 1200,
    },
  },
});
